import React from 'react';
import './contact.css';
import ContactUs from './components/ContactUs';

function Contact() {
  return (
    <div>
      <div className="banner-section-contact">
        <h1 className="banner-title-contact" style={{ color: "white" }}> Contact Us</h1>
      </div>
      <ContactUs />
    </div>
  );
}

export default Contact;
